"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "villafranca-padovana": {
    "fc69ab10": [{
      "hkey": "a76de26d",
      "slug": "ronchi-di-campanile",
      "name": "Ronchi di Campanile",
      "primary": true,
      "skipSearch": false
    }],
    "taggi-di-sopra-e-ronchi-di-campanile": [{
      "hkey": "a76de26d",
      "slug": "ronchi-di-campanile",
      "name": "Ronchi di Campanile",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "8335ef88": [{
      "hkey": "5c0c1112",
      "slug": "taggi",
      "name": "Taggì",
      "primary": true,
      "skipSearch": false
    }],
    "taggi-di-sotto": [{
      "hkey": "5c0c1112",
      "slug": "taggi",
      "name": "Taggì",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;